<template>
    <d-card :class="['stats-small', computedVariationClass, 'card', 'card-small']">
        <d-card-body class="pt-2" :class="[computedBodyClass]">
            <div v-if="!isLoading" :class="['d-flex', computedInnerWrapperClass]">
                <div :class="['stats-small__data', computedDataFieldClass]">
                    <span :class="['stats-small__label', 'text-uppercase', computedLabelClass]">{{ label }}</span>
                    <h6 :class="['stats-small__value', 'count', computedValueClass]">{{ transactionAmount }}</h6>
                    <span :class="['stats-small__label', 'text-uppercase', computedLabelClass]">{{ transactionLabel }}</span>
                </div>
                <div :class="['stats-small__data', computedInnerDataFieldClass]">
                    <br>
                    <h6 :class="['stats-small__value', 'count', computedValueClass]">€{{ transactionSum }}</h6>
                    <span :class="['stats-small__label', 'text-uppercase', computedLabelClass]">{{ amountLabel }}</span>
                </div>
            </div>
            <d-container class="d-flex justify-content-center mt-5" fluid v-else>
                <b-spinner label="Spinning"></b-spinner>
            </d-container>
            <small-graph :chart-data="chartData" />
        </d-card-body>
    </d-card>
</template>

<script>
import Chart from '../../utils/chart';
import { nanoid } from '../../utils';
import SmallGraph from './SmallGraph.vue';

export default {
    components: {
        SmallGraph
    },

    name: 'd-small-stats',
    props: {
        label: {
            type: String,
            default: 'Label',
        },

        isLoading: {
            type: Boolean
        },
 
        transactionLabel: {
            type: String,
            default: 'transactionLabel',
        },
   
        amountLabel: {
            type: String,
            default: 'amountLabel',
        },
  
        transactionAmount: {
            type: [Number, String],
            default: 0,
        },
   
        transactionSum: {
            type: [Number, String],
            default: 0,
        },
  
        percentage: {
            type: [Number, String],
            default: 0,
        },

        increase: {
            type: Boolean,
            default: true,
        },

        decrease: {
            type: Boolean,
            default: false,
        },

        chartOptions: {
            type: Object,
            default() {
                return {};
            },
        },
   
        chartData: {
            type: Array,
            required: true,
            default() {
                return [];
            },
        },
  
        chartConfig: {
            type: Object,
        },
    
        variation: {
            type: String,
            default: null,
        }
    },

    computed: {
        computedPercentageModifier() {
            return this.increase ? 'increase' : 'decrease';
        },

        computedVariationClass() {
            return this.variation ? `stats-small--${this.variation}` : null;
        },

        computedBodyClass() {
            if (this.variation === '1') {
                return 'p-0 d-flex';
            }

            return 'px-0 pb-0';
        },

        computedInnerWrapperClass() {
            if (this.variation === '1') {
                return 'flex-column m-auto';
            }

            return 'px-3';
        },

        computedDataFieldClass() {
            if (this.variation === '1') {
                return 'text-center';
            }

            return null;
        },

        computedLabelClass() {
            if (this.variation === '1') {
                return null;
            }

            return 'mb-1';
        },

        computedValueClass() {
            if (this.variation === '1') {
                return 'my-3';
            }

            return 'm-0';
        },
        
        computedInnerDataFieldClass() {
            if (this.variation === '1') {
                return null;
            }

            return 'text-right align-items-center';
        }
    }
};

</script>

<style lang="scss">
  /* IE11 height and chart positioning fix */
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .card-body {
      min-height: 140px;
      position: relative;
    }

    .stats-small canvas {
      left: 0;
    }

    .stats-small--1 .stats-small__data {
        align-items: center !important;
        padding-top: 20px;
    }
  }
</style>
